import { Link } from "react-router-dom";
import { allSubtitles } from "@/utils/subtitles";

const stats = [
  { value: "6,800+", label: "收录字幕资源" },
  { value: "150万+", label: "累计下载次数" },
  { value: "每日", label: "更新最新字幕" },
  { value: "4 大类", label: "影视类型覆盖" },
];

export default function IntroSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-shield-check-line text-sm"></i>
              专业字幕资源站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              免费高清中文字幕，快速找到你要的那一份
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              中文在线字幕免费高清专注于汇集各类影视作品的高清中文字幕资源。无论你是想为外语影片配上中文字幕，
              还是希望研究字幕排版与翻译技巧，都能在这里按电影、电视剧、综艺、动漫等分类高效筛选，
              在线预览字幕文本片段，并下载 SRT、ASS 等格式的字幕文件。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              全站资源均标注格式、语言、文件大小与更新时间，信息层级清晰，帮助你快速判断是否匹配自己的片源版本。
              当前站内 {allSubtitles.length} 条示范资源用于展示检索、预览与下载的完整流程。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/search"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-search-line text-lg"></i>
                开始搜索字幕
              </Link>
              <Link
                to="/about"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300"
              >
                <i className="ri-information-line text-lg"></i>
                了解本站
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((item, index) => (
              <div
                key={item.label}
                className={`rounded-lg border p-5 ${
                  index % 3 === 1
                    ? "border-accent-200 bg-accent-50"
                    : "border-background-200 bg-background-50"
                }`}
              >
                <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
                  {item.value}
                </p>
                <p className="mt-2 text-sm text-foreground-600">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}